import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { VendorBanksController } from './vendor-banks.controller';
import { VendorBanksService } from './vendor-banks.service';
import { VendorBanksLogEntity } from './vendor-banks-log.entity';
import { vendorBanksEntity } from './vendor-banks.entity';




@Module({
  imports: [
    TypeOrmModule.forFeature([vendorBanksEntity,VendorBanksLogEntity]),
  ],
  controllers: [VendorBanksController],
  providers: [VendorBanksService, ApplicationExceptionHandler,LogsService]
})
export class VendorBanksModule { }
